import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import ScreenLoader from '../components/ScreenLoader'
import '../common/styles/base.scss'

class App extends React.Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (
            <Provider store={this.props.store}>
                <React.Fragment>
                    <Router basename='/'>
                        <Switch>
                            {this.props.routes.map((r, i) => {
                              const Component = r.component
                              const Index = r.indexRoute()
                              const render = () => <Component><Index/></Component>
                              return (
                                    <Route
                                        key={i}
                                        exact
                                        path={r.path}
                                        render={render}
                                    />
                              )
                            })}
                        </Switch>
                    </Router>
                    <ScreenLoader/>
                </React.Fragment>
            </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./main/src/containers/App.js